import { OktaAuth, OktaAuthOptions } from '@okta/okta-auth-js'

const oktaConfig: OktaAuthOptions = {
  issuer: process.env.REACT_APP_OKTA_ISSUER,
  redirectUri: `${window.location.origin}/implicit/callback`,
  clientId: 'nike.niketech.shipment-deliveryview',
  scopes: [
    'default',
    'openid',
    'profile',
    'email',
    'ship:carrier.config.service.config::read:',
    'demand_planning:rebooking.delivery.view.shipments::read:',
    'demand_planning:carrierint.shipmenttracking.ui::execute:',
    'demand_planning:carrierint.rebooking.service.rebookings::read:',
  ],
  services: {
    autoRenew: true,
    autoRemove: true,
    syncStorage: true,
  },
  pkce: true,
}

export const oktaAuth = new OktaAuth(oktaConfig)

export const getOktaAuth = () => oktaAuth
